module.exports = __webpack_public_path__ + "static/img/ydybtnmf.e9ca89a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ydybtnmf.jpg
// module id = 8so7
// module chunks = 1